import React from 'react';

type FormFieldProps = {
  label?: React.ReactNode;
  htmlFor?: string;
  children: React.ReactNode;
};

// grow-ui's Form.Field: the label on its own line above the control. Relative
// so the control's absolutely positioned message sits under it.
const FormField = ({ label, htmlFor, children }: FormFieldProps) => (
  <div className="relative my-4 w-full">
    {label && (
      <label htmlFor={htmlFor} className="block text-gray-700 font-medium">
        {label}
      </label>
    )}
    {children}
  </div>
);

export default FormField;
